module.exports = __webpack_public_path__ + "static/media/food-industry.6bdb10db.png";